import { useState, useEffect } from 'react';
import React from 'react';
import { getHostApi } from '../../../utils';
import { FormGenerateTexture } from './components/iUpload';
import { deleteTexture } from './UploadActions.api';

interface RequestQueueProps {
  data?: FormGenerateTexture;
  updateTextureGlb: (creationId: string, glbLoading: boolean, glbVersion?: number | null) => void;
  idCommande: number;
}

function RequestQueue({data, updateTextureGlb, idCommande}: RequestQueueProps) {
  const [requestQueue, setRequestQueue] = useState<FormGenerateTexture[]>([]);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  useEffect(() => {
    const processQueue = async () => {
      const nextRequest = requestQueue[requestQueue.length - 1];
      setIsProcessing(true);
      
      const creationIdArray = nextRequest.creationId.split('/');
      const creationId = creationIdArray[creationIdArray.length - 1];
      try {
        if(nextRequest.files.length > 0) {
          updateTextureGlb(creationId, true);
          await fetch(`${getHostApi()}/uploads/generate-texture/product/${nextRequest.productId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(nextRequest)
          });
        } else {
          await deleteTexture(creationId, idCommande);
          updateTextureGlb(creationId, false, null);
        }
      } catch (error) {
        console.log(error)
      } finally {
        requestQueue[requestQueue.length - 1].done = true;
        setIsProcessing(false);
      }
    };
    if (requestQueue.length > 0 && !isProcessing && !requestQueue[requestQueue.length - 1].done) {
      processQueue();
    } else if(!isProcessing && data) {
      updateTextureGlb(data.creationId.split('/').pop() ?? '', false);
    } else if (data && data.files.length === 0) {
      updateTextureGlb(data.creationId.split('/').pop() ?? '', false, null);
    }
  }, [requestQueue, isProcessing]);

  useEffect(() =>{
    if(data) {
      setRequestQueue([data]);
    }
  },[data])

  return <></>;
}

export default RequestQueue;